module.exports = __webpack_public_path__ + "images/8dae26e5899dcea36c95ea20799585ce-side_bar_bg.jpg";